import { useState } from 'react';
import { changeOrderStatus, type OrderStatusChangeResult } from './api/orderStatusApi';

export interface OrderStatusFormValues {
  status: string;
  notes?: string;
}

interface UseOrderStatusChangeWithConfirmationOptions {
  orderId?: string | null;
  /** Receives the saved status and any non-blocking operational context. */
  onSuccess: (values: OrderStatusFormValues, result: OrderStatusChangeResult) => void | Promise<void>;
  onError: (error: unknown) => void;
}

export function useOrderStatusChangeWithConfirmation({
  orderId,
  onSuccess,
  onError,
}: UseOrderStatusChangeWithConfirmationOptions) {
  const [submitting, setSubmitting] = useState(false);

  const submitStatusChange = async (values: OrderStatusFormValues) => {
    if (!orderId) return;

    setSubmitting(true);
    try {
      const result = await changeOrderStatus(orderId, values);
      await onSuccess(values, result);
    } catch (error: any) {
      onError(error);
    } finally {
      setSubmitting(false);
    }
  };

  return {
    submitting,
    submitStatusChange,
  };
}
